import { type SetState } from '../store';
import { type Region } from '@/types/constants';

export type RegionInfoSliceProps = {
    regionInfo: {
        currentRegion: {
            region: Region;
        };
        setRegion: (params: string) => void;
        showRegionSelector: boolean;
        setShowRegionSelector: (params: string) => void;
    };
};

export const regionInfoSlice = ({ set }: SetState<RegionInfoSliceProps>): RegionInfoSliceProps => ({
    regionInfo: {
        currentRegion: {
            region: 'CT' // TODO: read from middleware or get default locale
        },
        setRegion: (params) =>
            set(
                (state) => ({
                    regionInfo: {
                        ...state.regionInfo, // TODO: discuss using Immer https://immerjs.github.io/immer/
                        currentRegion: {
                            ...state.regionInfo.currentRegion,
                            region: params
                        }
                    }
                }),
                undefined,
                'setRegion'
            ),
        showRegionSelector: true, // TODO: read from headers
        setShowRegionSelector: (params) =>
            set(
                (state) => ({
                    regionInfo: {
                        ...state.regionInfo, // TODO: discuss using Immer https://immerjs.github.io/immer/
                        currentRegion: {
                            ...state.regionInfo.currentRegion,
                            region: params
                        }
                    }
                }),
                undefined,
                'setShowRegionSelector'
            )
    }
});
